// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ModificationTabs from "./ModificationTabs.bs.js";
import * as MuiTabs$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/tabs/MuiTabs.bs.js";
import * as ModificationListView from "./ModificationListView.bs.js";
import * as ModificationsProvider from "../../../../library/modifications-context/ModificationsProvider.bs.js";
import * as PricingDashboardAssetsManager from "../../../../../assets/PricingDashboardAssetsManager.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

var info_icon = PricingDashboardAssetsManager.getImage("info-icon.svg");

function ModificationsTabView$PendingCampaignWarning(Props) {
  return React.createElement("div", {
              className: "c-warning-banner modification-warning"
            }, React.createElement("img", {
                  src: info_icon
                }), React.createElement("p", undefined, "NOTE: Core Pricing Campaign needs to be approved first in order to approve the Modifications"));
}

var PendingCampaignWarning = {
  info_icon: info_icon,
  make: ModificationsTabView$PendingCampaignWarning
};

function ModificationsTabView(Props) {
  var core_pricing = Props.core_pricing;
  var modifications = Props.modifications;
  var zones = Props.zones;
  var clusters = Props.clusters;
  var refetchModifications = Props.refetchModifications;
  var modified_priorities = Props.modified_priorities;
  var initial_priorities = Props.initial_priorities;
  var edited_modifications = Props.edited_modifications;
  var dispatch = Props.dispatch;
  var active_tab = Props.active_tab;
  var toggleModificationTab = Props.toggleModificationTab;
  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
              loadableData: modifications,
              children: (function (modifications) {
                  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
                              loadableData: zones,
                              children: (function (zones) {
                                  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
                                              loadableData: clusters,
                                              children: (function (clusters) {
                                                  return React.createElement(ModificationsProvider.make, ModificationsProvider.makeProps({
                                                                  refetchModifications: refetchModifications,
                                                                  openPendingPrioritiesTab: (function (param) {
                                                                      return Curry._1(toggleModificationTab, (function (param) {
                                                                                    return /* PendingPriorities */1;
                                                                                  }));
                                                                    }),
                                                                  zones: zones,
                                                                  clusters: clusters,
                                                                  modified_priorities: modified_priorities,
                                                                  initial_priorities: initial_priorities,
                                                                  edited_modifications: edited_modifications
                                                                }, null, undefined), core_pricing.status === /* Pending */1 ? React.createElement(ModificationsTabView$PendingCampaignWarning, {}) : null, React.createElement("div", {
                                                                  className: "c-modification-tabs"
                                                                }, React.createElement(MuiTabs$Catalyst.make, {
                                                                      tabs: ModificationTabs.tabs,
                                                                      activeTab: active_tab,
                                                                      setActiveTab: toggleModificationTab
                                                                    })), React.createElement(ModificationListView.make, {
                                                                  active_tab: active_tab,
                                                                  modifications: modifications,
                                                                  core_pricing: core_pricing,
                                                                  dispatch: dispatch
                                                                }));
                                                })
                                            });
                                })
                            });
                })
            });
}

var make = ModificationsTabView;

export {
  PendingCampaignWarning ,
  make ,
  
}
/* info_icon Not a pure module */
